import { Auth } from 'aws-amplify';

export function resetPassAPI(email, password, code) {
  return Auth.forgotPasswordSubmit(email, code, password);
}
